import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Rating', method: 'GET', token: token })
}
